import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Button as ButtonComponent, Typography } from '@raisin/components-lib';

export const RiskBannerContainer = styled(Grid)(({ theme }) => ({
  '& > div': {
    maxWidth: '100%',
    marginTop: theme.spacing(6),
  },
}));

export const DetailsContainer = styled(Grid)({
  cursor: 'auto',
});

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.subtitle1.fontWeight,
}));

export const Button = styled(ButtonComponent)({
  justifyContent: 'left',
});
